import { createStore } from "vuex";
import * as movie from "@/store/modules/movie";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    movie,
  },
});
